<div class='happy-car-container d-sm-none'>
  <img src='/assets/images/happy-car.svg' alt="" >
</div>
<p *ngIf="redirectUrl !== ''" class="text-center">
  {{'partnerRedirectMsg' | T}}
</p>
<cp-signup-footer-controls [showBackButton]="false" [nextButtonText]="nextButton" (nextClicked)="navigateToRedirect()"></cp-signup-footer-controls>

